import { render, staticRenderFns } from "./bookmark-add.vue?vue&type=template&id=fe9651a2&"
import script from "./bookmark-add.vue?vue&type=script&lang=ts&"
export * from "./bookmark-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports